export default __webpack_public_path__ + "static/3-519b99fa4b11c22e2b29398569e73ded.jpeg";